export default __webpack_public_path__ + "static/media/message.9dd5af34.svg";